module.exports = __webpack_public_path__ + "static/media/Audio.f87d3211.svg";